<div class="registaration">
  <div class="r-header">
    <img src="../../../../assets/images/logo-dark.svg" alt="">
  </div>
  <div class="sidebar">
    <img src="../../../../assets/images/logo2.svg" class="logo" alt="">
    <h2>
      Reset your password in a few seconds and get back to creating and monitoring your campaigns on the LuQta
      Dashboard
    </h2>
    <img src="../../../../assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
  </div>
  <div class="form-body">
    <div class="cant-have-account">
      <a [href]="baseUrl" class="back-to-home">
        <i class="fa-solid fa-arrow-left"></i>
        <span>Go to Home</span>
      </a>
      <div class="account">
        <span>
          Don’t have an account?
        </span>
        <a [routerLink]="'/auth/signup'">
          Sign up
        </a>
      </div>
    </div>

    <form [formGroup]="ResetForm" (ngSubmit)="onSubmit()">
      <div class="form-card">
        <h3 class="title">
          New Password
        </h3>
        <p>
          No worries! Just enter your new password and confirm it below.
        </p>

        <!-- New Password -->
        <!-- New Password -->
        <div class="input-group position-relative">
          <input [type]="isPasswordVisible ? 'text' : 'password'" class="form-control" id="newPassword"
            formControlName="new_password" placeholder="Create new password" (input)="onPasswordInput()" />

          <!-- eye icon (will NOT trigger form touched) -->
          <span (mousedown)="$event.preventDefault()" (click)="togglePasswordType('new_password')"
            style="cursor: pointer;">
            <i [ngClass]="
        isPasswordVisible
          ? 'fa -solid fa-eye'
          : 'fa -solid fa-eye-slash'
      "></i>
          </span>

          <!-- ERROR BLOCK WITH FIXED HEIGHT (no layout shake) -->
          <div style="min-height: 20px; margin-top: 2px;">
            <span class="error text-danger" *ngIf="
        ResetForm.controls['new_password'].touched &&
        ResetForm.controls['new_password'].invalid
      ">
              <!-- EMPTY FIELD -->
              <span *ngIf="ResetForm.controls['new_password'].errors?.['required']">
                Password is required.
              </span>

              <!-- INVALID FIELD -->
              <span *ngIf="
          !ResetForm.controls['new_password'].errors?.['required'] &&
          ResetForm.controls['new_password'].invalid
        ">
                The minimum password length should be 8 characters.
                It should contain one uppercase letter, one special character,
                and one number.
              </span>
            </span>
          </div>
        </div>


        <!-- Confirm Password -->
        <div class="input-group position-relative">
          <input [type]="isConfirmPasswordVisible ? 'text' : 'password'" class="form-control" id="confirmPassword"
            formControlName="confirmpassword" placeholder="Confirm password" />

          <!-- prevent focus loss when clicking eye icon -->
          <span (mousedown)="$event.preventDefault()" (click)="togglePasswordType('confirmpassword')"
            style="cursor: pointer;">
            <i [ngClass]="
        isConfirmPasswordVisible
          ? 'fa -solid fa-eye'
          : 'fa -solid fa-eye-slash'
      "></i>
          </span>

          <!-- Fixed height to avoid shaking -->
          <div style="min-height: 20px; margin-top: 2px;">
            <span class="error text-danger" *ngIf="
        ResetForm.controls['confirmpassword'].touched &&
        ResetForm.controls['confirmpassword'].invalid
      ">
              <!-- Required message -->
              <span *ngIf="ResetForm.controls['confirmpassword'].errors?.['required']">
                Confirm password is required
              </span>
            </span>

            <!-- Password mismatch message -->
            <span class="error text-danger" *ngIf="
        ResetForm.controls['confirmpassword'].touched &&
        ResetForm.errors?.['passwordsMismatch'] &&
        !ResetForm.controls['confirmpassword'].errors?.['required']
      ">
              Passwords do not match
            </span>
          </div>
        </div>


        <!-- Submit -->
        <button class="btn btn-primary btn-md w-100" type="submit" [disabled]="!canSubmit()">
          Reset Password
        </button>

        <div class="just-remember">
          Remember your password?
          <a [routerLink]="'/auth/login'">
            Sign in
          </a>
        </div>
      </div>
    </form>

    <div class="download-app">
      <div class="row">
        <div class="col-lg-7">
          <h3>
            Want to partcipate in campaigns and win valuable prizes?
            <br>
            Download the LuQta app now!
          </h3>
        </div>
        <div class="col-lg-5">
          <div class="app-buttons">
            <a href="https://apps.apple.com/qa/app/luqta/id6752577067" terget="_blank">
              <img src="../../../../assets/images/apple.svg" class="app-btn" alt="" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=io.luqta.application" terget="_blank">
              <img src="../../../../assets/images/android.svg" class="app-btn" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>